import React, { forwardRef, ReactElement } from 'react';
import type { TooltipProps } from '@mui/material';
import { Tooltip as TooltipMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

import { maxWidthMapping } from './Tooltip.api';

type Props = {
  children: ReactElement;
  title?: string;
  open?: boolean;
  placement?: string;
  maxWidth?: keyof typeof maxWidthMapping;
};

const Tooltip = forwardRef<HTMLElement, TooltipProps & Props>(
  ({ children, title, maxWidth, slotProps, ...props }, ref) => (
    <TooltipMUI
      title={title}
      {...omitUndefinedProps({
        ...props,
        open: !title ? false : props.open,
      })}
      slotProps={{
        ...(slotProps || {}),
        tooltip: {
          ...(slotProps?.tooltip || {}),
          style: {
            ...(slotProps?.tooltip?.style || {}),
            maxWidth: maxWidth && maxWidth !== 'sm' ? maxWidthMapping[maxWidth] : undefined,
          },
        },
      }}
      ref={ref}
    >
      {children}
    </TooltipMUI>
  ),
);

Tooltip.displayName = 'Tooltip';

export default Tooltip;
